import '../App.css';
import MinesweeperTogether from '../assets/MinesweeperTogether.png';
import Munchify from '../assets/Munchify.png';
import SportCred from '../assets/SportCred.png';
import Ninversion from '../assets/Ninversion.png';
import StudyBud from '../assets/StudyBud.png';

const Projects = () => {
    return (
        <div id='section-3' className='Project'>
            <div className='Header'>
            PROJECTS
            </div>
            <div className='Grid'>
                <a href='https://minesweepertogether.com' className='Card'>
                    <div className='Card_Image' style={{ backgroundImage: `url(${MinesweeperTogether})` }}>
                    <div className='Desc_Title'>minesweepertogether.com</div>
                    <div className='Desc_Info'>Personal project to make a fun minesweeper game online that can be played together with friends.</div>
                    </div>
                </a>
                <a href='https://devpost.com/software/munchify' className='Card'>
                    <div className='Card_Image' style={{ backgroundImage: `url(${Munchify})` }}>
                    <div className='Desc_Title'>MUNCHIFY</div>
                    <div className='Desc_Info'>UofT Hacks hackathon project, a social media app to easily share recipes with friends.</div>
                    </div>
                </a>
                <a href='https://docs.google.com/presentation/d/1UswiVKmQa7E09IKsLOksqPpJYcUIqXPNUnnOx5I2kpY/edit?usp=sharing' className='Card'>
                    <div className='Card_Image' style={{ backgroundImage: `url(${SportCred})` }}>
                    <div className='Desc_Title'>SPORTCRED</div>
                    <div className='Desc_Info'>Course project with real clients to create a mobile app for sports pick-ems and discussions.</div>
                    </div>
                </a>
                <a href='https://itch.io/jam/utsc-game-devs-game-jam-2020/rate/575581' className='Card'>
                    <div className='Card_Image' style={{ backgroundImage: `url(${Ninversion})` }}>
                    <div className='Desc_Title'>NINVERSION</div>
                    <div className='Desc_Info'>UTSC GameJam 2020 submission, a 2D Puzzle Platformer with inverting cameras and smooth movement.</div>
                    <div className='Desc_Info'> Won 2nd place.</div>
                    </div>
                </a>
                <a href='https://devpost.com/software/studybud' className='Card'>
                    <div className='Card_Image' style={{ backgroundImage: `url(${StudyBud})`}}>
                    <div className='Desc_Title'>STUDYBUD</div>
                    <div className='Desc_Info'>Hack the North project, chrome extension to help with studying and essay writing.</div>
                    </div>
                </a>
            </div>
        </div>
    );
}

export default Projects;